import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { Box, Stack } from '../../../imports/muiImport';
import MobileSectionTitle from './MobileSectionTitle';
import { NavLink } from 'react-router-dom';
import { titleToUrl } from '../../../shared/extra';

const sectionGap = 1.2;
const sectionRadius = 2;

const MobileListVoucher = (props) => {
  const { title, products, redirectLink, defaultImages } = props;
  const [productLoading, setProductionLoading] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);

  const filterData = () => {
    if (products?.length > 0) {
      const large = products?.filter((item) => item?.img_size === 'L');
      const small = products?.filter((item) => item?.img_size === 'S');
      const medium = products?.filter((item) => item?.img_size === 'M');
      const finalArr = [large?.[0], medium?.[0], small?.[0], small?.[1], medium?.[1]];

      setFilteredProducts(finalArr);
      setProductionLoading(false);
    } else {
      console.log('product not found');
    }
  };

  useEffect(() => {
    setProductionLoading(true);
    if (products?.length > 0) {
      filterData();
    }
  }, [products?.length]);

  if (productLoading) {
    return (
      <Box
        sx={{
          minHeight: '30vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      component={'div'}
      sx={{
        my: 3,
        px: 1,
        pb: 1.5,
        backgroundColor: 'white.main',
      }}
    >
      {title && (
        <Stack
          sx={{
            mb: 1,
          }}
        >
          <MobileSectionTitle
            sectionTitle={title}
            buttonText={'view all'}
            redirectLink={redirectLink}
          />
        </Stack>
      )}

      <Box
        component={'div'}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: sectionGap,
          mb: 0.5,
        }}
      >
        {filteredProducts?.[0]?.category_wise ? (
          <RedirectableGiftCard
            data={filteredProducts?.[0]}
            image={filteredProducts?.[0]?.category_wise}
            width={'100%'}
            height={'auto'}
            objectFit={'cover'}
          />
        ) : (
          <GiftCardComponent
            image={defaultImages?.largeImage1}
            width={'100%'}
            height={'auto'}
            objectFit={'cover'}
          />
        )}
      </Box>

      <Box
        component={'div'}
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          columnGap: sectionGap,
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: sectionGap,
          }}
        >
          {filteredProducts?.[1]?.category_wise ? (
            <RedirectableGiftCard
              data={filteredProducts?.[1]}
              image={filteredProducts?.[1]?.category_wise}
              width={'100%'}
              height={'261px'}
              objectFit={'cover'}
            />
          ) : (
            <GiftCardComponent
              image={defaultImages?.mediumImage1}
              width={'100%'}
              height={'261px'}
              objectFit={'cover'}
            />
          )}

          {filteredProducts?.[2]?.category_wise ? (
            <RedirectableGiftCard
              data={filteredProducts?.[2]}
              image={filteredProducts?.[2]?.category_wise}
              width={'100%'}
              height={'126px'}
              objectFit={'cover'}
            />
          ) : (
            <GiftCardComponent
              image={defaultImages?.smallImage1}
              width={'100%'}
              height={'126px'}
              objectFit={'cover'}
            />
          )}
        </Box>

        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: sectionGap,
          }}
        >
          {filteredProducts?.[3]?.category_wise ? (
            <RedirectableGiftCard
              data={filteredProducts?.[3]}
              image={filteredProducts?.[3]?.category_wise}
              width={'100%'}
              height={'126px'}
              objectFit={'cover'}
            />
          ) : (
            <GiftCardComponent
              image={defaultImages?.smallImage2}
              width={'100%'}
              height={'126px'}
              objectFit={'cover'}
            />
          )}

          {filteredProducts?.[4]?.category_wise ? (
            <RedirectableGiftCard
              data={filteredProducts?.[4]}
              image={filteredProducts?.[4]?.category_wise}
              width={'100%'}
              height={'261px'}
              objectFit={'cover'}
            />
          ) : (
            <GiftCardComponent
              image={defaultImages?.mediumImage2}
              width={'100%'}
              height={'261px'}
              objectFit={'cover'}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MobileListVoucher;

const RedirectableGiftCard = (props) => {
  const { data, image, width, height, objectFit } = props;
  const link = `/card-details/${data?.id}/${titleToUrl(data?.title)}${
    data?.url_utm ? `?${data?.url_utm}` : ''
  }`;

  return (
    <NavLink to={link} style={{ textDecoration: 'none' }}>
      <GiftCardComponent
        image={image}
        width={width}
        height={height}
        altText={`${titleToUrl(data?.title)}-giftcard-image `}
        objectFit={objectFit}
      />
    </NavLink>
  );
};

const GiftCardComponent = (props) => {
  return (
    <Box
      component={'div'}
      sx={{
        width: `${props?.width || '100%'}`,
        height: {
          xs: `${props?.height || 'auto'}`,
          sm: 'auto',
        },
        overflow: 'hidden',
      }}
    >
      <Box
        component={'img'}
        src={props?.image}
        alt={props?.altText || '99gift product image'}
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: sectionRadius,
          // objectFit: `${props?.objectFit || 'contain'}`
        }}
      />
    </Box>
  );
};
